<template>
  <div class="app-container">
    <Navbar :msg="resourceName | shortRoomName"/>
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { mapState } from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'app',
  computed: {
    ...mapState(['resourceCalendars', 'currentResourceId']),
    resourceName () {
      let item = this.resourceCalendars.find(i => i.id === this.currentResourceId)
      return item ? item.summary : ''
    }
  },
  components: {
    Navbar,
  },
  mounted: function () {
    let currentDate = dayjs()
    // reloading the page for new updates
    const twoHours = 7200 * 1000
    setInterval(function () {
      if (currentDate.$H >= 0 && currentDate.$H <= 2) {
        location.reload(true)
      }
    }, twoHours)
  }
}
</script>

<style lang="scss">
  @import "./assets/variables.scss";

  body {
    background-color: $grey-darker;
     box-shadow: inset 0px 0px 10px rgba($color: #fff, $alpha: .5);
    height: 100vh;
    .app-container {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .navbar {
        max-height: 2rem;
    }
  }
</style>
